import ShoppingBag from './ShoppingBag';

export default ShoppingBag;
